export const MAIN_HEADER_MODULE = {
  ACTION_TYPES: {
    switchClick: 'switchClick',
    searchClick: 'searchClick',
    settingsClick: 'settingsClick',
    buzzClick: 'buzzClick',
    mainLogoClick: 'mainLogoClick',
    liveSwitchClick: 'liveSwitchClick',
    bolaoClick: 'bolaoClick',
  },

  ANALYTICS: {
    BUZZ_URL_CHARACTERS: 50
  },

  EXPANDABLE_ITEMS: {
    dropdown: -1,
    min: 3,
    max: 7,
  },

  NO_SELECTED_TAB: -1,
  MY_SCORES_TAB_ID: 0,
  MAIN_HEADER_DESKTOP_HEIGHT : 64,
  MAIN_HEADER_MOBILE_HEIGHT : 80,
  MAIN_HEADER_DESKTOP_TABS_OFFSET: 500,
  AVERAGE_TAB_SIZE: 100,
  ICON_SIZE: 20,
}

export const BUZZ_URL = {
  "ar": {
    url: 'https://www.365scores.com/ar/news/magazine/?utm_source=365scores&utm_medium=webNews&utm_campaign=link',
    showOnlyInFooter: false,
    id: 2121
  },
  "pt": {
    url: 'https://www.365scores.com/pt-br/news/magazine/?utm_source=365scores&utm_medium=webNews&utm_campaign=link',
    showOnlyInFooter: false,
    id: 2065
  },
  "pt-br": {
    url: 'https://www.365scores.com/pt-br/news/magazine/?utm_source=365scores&utm_medium=webNews&utm_campaign=link',
    showOnlyInFooter: false,
    id: 2065
  },
  "es": {
    url: 'https://www.365scores.com/es/news/?utm_source=365scores&utm_medium=webNews&utm_campaign=link',
    showOnlyInFooter: false,
    id: 2262
  },
  "es-mx": {
    url: 'https://www.365scores.com/es/news/?utm_source=365scores&utm_medium=webNews&utm_campaign=link',
    showOnlyInFooter: false,
    id: 2262
  },
  "en": {
    url: 'https://www.365scores.com/news/?utm_source=365scores&utm_medium=webNews&utm_campaign=link',
    showOnlyInFooter: true,
    id: 2260
  },
  "en-us": {
    url: 'https://www.365scores.com/news/?utm_source=365scores&utm_medium=webNews&utm_campaign=link',
    showOnlyInFooter: true,
    id: 2260
  },
  "en-uk": {
    url: 'https://www.365scores.com/news/?utm_source=365scores&utm_medium=webNews&utm_campaign=link',
    showOnlyInFooter: true,
    id: 2260
  }
}
